import PageSection from 'components/PageSection';
import { Body1, SectionTitle } from 'components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SolutionSectionFive = () => {
    const { t } = useTranslation('solutionLandlord');
    return (
        <PageSection
            color="inverted"
            containerClass="flex flex-col-reverse lg:flex-row lg:items-center gap-16"
            className="py-32"
        >
            <div className="w-full lg:w-2/5"></div>
            <div className="w-full lg:w-3/5">
                <SectionTitle className="fade-in-scroll text-secondary">{t('sectionFive.title')}</SectionTitle>
                <Body1 className="fade-in-scroll pt-4 lg:max-w-xl">{t('sectionFive.body1')}</Body1>
                <Body1 className="fade-in-scroll pt-4 lg:max-w-xl">{t('sectionFive.body2')}</Body1>
                <Body1 className="fade-in-scroll pt-4 lg:max-w-xl">{t('sectionFive.body3')}</Body1>
            </div>
        </PageSection>
    );
};

export default SolutionSectionFive;
